import gql from 'graphql-tag'
import api from './apiClient'

export default {
  getRecords: (_idEmisor, filter) =>
    api
      .send({
        query: gql`
          query GET_RECORDS($_idEmisor: ID!, $filter: FilterInput!) {
            Record {
              getRecords(_idEmisor: $_idEmisor, filter: $filter) {
                _id
                emisor
                entidad {
                  _id
                  cuentaContable
                  accountName
                  nombre
                  code
                }
                documento {
                  _id
                  tipo
                  consecutivo
                }
                moneda {
                  _id
                  value
                  simbolo
                  tipoCambio
                }
                items {
                  _id
                  cuentaContable
                  debe
                  haber
                  accountName
                  code
                  createdAt
                  updatedAt
                }

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: {
          _idEmisor,
          filter
        }
      })
      .then(result => result.data.data.Record.getRecords),

  getLogs: (_idEmisor, _id) =>
    api
      .send({
        query: gql`
          query GET_LOGS($_idEmisor: ID!, $_id: ID!) {
            Record {
              getLogs(_idEmisor: $_idEmisor, _id: $_id) {
                _id
                user {
                  _id
                  fullname
                }
                oldAccount {
                  _id
                  code
                  name
                }
                newAccount {
                  _id
                  code
                  name
                }
                message
                createdAt
              }
            }
          }
        `,
        variables: {
          _idEmisor,
          _id
        }
      })
      .then(result => result.data.data.Record.getLogs),

  update: (_idEmisor, _idRecord, _idItem, cuentaContable, razon) =>
    api
      .send({
        query: gql`
          mutation UPDATE($_idEmisor: ID!, $_idRecord: ID!, $_idItem: ID!, $cuentaContable: ID!, $razon: String!) {
            Record {
              update(_idEmisor: $_idEmisor, _idRecord: $_idRecord, _idItem: $_idItem, cuentaContable: $cuentaContable, razon: $razon)
            }
          }
        `,
        variables: {
          _idEmisor,
          _idRecord,
          _idItem,
          cuentaContable,
          razon
        }
      })
      .then(result => result.data.data.Record.update)
}
